import { Navbar, Footer } from "@/components/landing";
import { EquipCaseStudy } from "@/components/work/equip/EquipCaseStudy";

export function WorkEquipPage() {
  return (
    <div className="page text-ink">
      <Navbar />
      <main>
        <div className="h-24 lg:h-28" aria-hidden="true" />
        <EquipCaseStudy />
      </main>
      <Footer />
    </div>
  );
}
